(function () {
    'use strict';

    angular.module('app').factory('UploadUtilities', UploadUtilitiesFactory);

    function UploadUtilitiesFactory() {

        const service = {
            ValidateExtensions: validateExtensions,
            ParseAttachment: parseResponse
        };

        return service;

        function validateExtensions(fileItem, extensions) {
            if (!Array.isArray(extensions) || extensions.some(e => !e.startsWith("."))) {
                console.error('UploadUtilities.ValidateExtensions: Invalid parameter - extensions');
                return false;
            }
            if (!fileItem || !fileItem.file || !fileItem.file.name)
                return false;

            const fileName = fileItem.file.name.toLowerCase();
            for (const extension of extensions.map(e => e.toLowerCase())) {
                if (fileName.endsWith(extension))
                    return true;
            }

            return false;
        }

        function parseResponse(response) {
            if (!CheckResultReceived(response))
                return;

            let attachment = response[0];
            // When is this hit?
            if (angular.isString(response) && (/^<pre>/).test(response)) {
                const data = response.replace(/<\/?pre>/ig, '');
                const parsed = angular.fromJson(data);
                attachment = parsed[0];
            }

            attachment.Uploaded = getDateFromAttachment(attachment);

            return attachment;
        }

        function getDateFromAttachment(attachment) {
            if (!attachment || !attachment.Uploaded)
                return new Date();
            return new Date(
                attachment.Uploaded.getUTCFullYear(),
                attachment.Uploaded.getUTCMonth(),
                attachment.Uploaded.getUTCDate(),
                attachment.Uploaded.getUTCHours(),
                attachment.Uploaded.getUTCMinutes(),
                attachment.Uploaded.getUTCSeconds());
        }
    }
})();